import { useState } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import { brandAdvantages, testimonials } from '@/mocks/comics';

const advantageImages = [
  'https://readdy.ai/api/search-image?query=Vast%20digital%20library%20of%20Korean%20webtoons%20displayed%20on%20floating%20panels%2C%20warm%20ambient%20lighting%2C%20organized%20collection%20aesthetic%2C%20elegant%20modern%20design%2C%20soft%20coral%20and%20cream%20tones&width=800&height=1067&seq=about-adv-01&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Fast%20digital%20update%20concept%20with%20glowing%20refresh%20symbols%2C%20dynamic%20motion%20blur%20effect%2C%20modern%20tech%20aesthetic%2C%20warm%20gradient%20background%2C%20sleek%20minimalist%20design&width=800&height=1067&seq=about-adv-02&orientation=portrait',
  'https://readdy.ai/api/search-image?query=High%20definition%20digital%20reading%20experience%20on%20tablet%20device%2C%20crystal%20clear%20display%2C%20immersive%20atmosphere%2C%20warm%20ambient%20light%2C%20elegant%20modern%20setup%2C%20soft%20focus%20background&width=800&height=1067&seq=about-adv-03&orientation=portrait',
];

export default function AboutPage() {
  const [testimonialIndex, setTestimonialIndex] = useState(0);
  const currentTestimonial = testimonials[testimonialIndex % testimonials.length];

  const pageTitle = '关于我们_韩国漫画网品牌介绍_免费韩漫平台';
  const pageDesc = '韩国漫画网致力于为广大漫画爱好者提供免费韩漫大全与好看的韩国漫画在线观看服务。了解我们的品牌故事、平台优势与联系方式。';

  return (
    <>
      <title>{pageTitle}</title>
      <meta name="description" content={pageDesc} />
      <meta name="keywords" content="韩国漫画网,关于我们,免费韩漫大全,韩漫在线观看,漫画平台" />
      <link rel="canonical" href="http://acwaterpump.com/about" />
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={pageDesc} />
      <meta property="og:url" content="http://acwaterpump.com/about" />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={pageDesc} />

      <script type="application/ld+json">{JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'AboutPage',
        name: pageTitle,
        description: pageDesc,
        url: 'http://acwaterpump.com/about',
        isPartOf: { '@type': 'WebSite', name: '韩国漫画网', url: 'http://acwaterpump.com/' },
      })}</script>

      <Navbar />

      <main className="pt-20">
        {/* Hero Section */}
        <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Elegant%20artistic%20Korean%20illustration%20style%20background%2C%20warm%20coral%20and%20cream%20tones%2C%20abstract%20flowing%20comic%20panel%20shapes%2C%20soft%20dreamy%20atmosphere%2C%20minimalist%20composition%2C%20airy%20and%20light%2C%20modern%20art%20direction%2C%20no%20text&width=1600&height=900&seq=about-hero-01&orientation=landscape"
            alt="关于韩国漫画网"
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/40"></div>

          <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-6">
            <h1 className="font-heading text-3xl md:text-6xl font-bold text-white text-center leading-tight">
              关于韩国漫画网
            </h1>
            <p className="mt-4 md:mt-6 text-sm md:text-lg text-white/80 text-center max-w-2xl">
              为漫画爱好者打造的一站式免费韩漫阅读平台
            </p>
          </div>
        </section>

        <div className="max-w-[1440px] mx-auto px-6 md:px-10">
          <Breadcrumb items={[
            { label: '首页', path: '/' },
            { label: '关于我们' },
          ]} />

          {/* Brand Story */}
          <section className="py-16 md:py-24">
            <div className="max-w-3xl mx-auto text-center">
              <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
                品牌故事
              </h2>
              <p className="mt-6 text-foreground-600 text-sm md:text-base leading-relaxed">
                韩国漫画网成立于2020年，由一群热爱韩国漫画的年轻人共同创建。我们深知韩漫爱好者在寻找高质量、免费韩漫资源时面临的困难，因此立志打造一个资源丰富、更新及时、体验流畅的免费韩漫大全平台。
              </p>
              <p className="mt-4 text-foreground-600 text-sm md:text-base leading-relaxed">
                经过数年的发展，韩国漫画网已成长为国内领先的韩漫在线阅读平台，收录超过5000部韩国漫画作品，涵盖恋爱、奇幻、动作、悬疑、搞笑等多种题材。我们始终坚持免费阅读的理念，让每一位漫画爱好者都能无门槛地享受韩漫的魅力。
              </p>
            </div>
          </section>
        </div>

        {/* Advantages - Feature Grid */}
        <section className="py-16 md:py-24 bg-background-100">
          <div className="max-w-[1440px] mx-auto px-6 md:px-10">
            <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 text-center">
              平台优势 ✦
            </h2>

            <div className="mt-12 md:mt-20 grid grid-cols-1 md:grid-cols-3 gap-6">
              {brandAdvantages.map((adv, index) => (
                <div
                  key={index}
                  className="group relative rounded-2xl overflow-hidden cursor-pointer transition-all duration-500"
                  style={{ height: '380px' }}
                >
                  <img
                    src={advantageImages[index]}
                    alt={adv.title}
                    className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>

                  <div className="absolute bottom-0 left-0 right-0 p-6">
                    <h3 className="font-heading text-xl md:text-2xl font-bold text-white">
                      {adv.title}
                    </h3>
                    <p className="mt-2 text-sm text-white/70 leading-relaxed opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                      {adv.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Testimonials */}
        <section className="py-16 md:py-24 max-w-[1440px] mx-auto px-6 md:px-10">
          <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">
            <div className="w-full lg:w-[40%]">
              <div className="rounded-[32px] overflow-hidden bg-secondary-300 aspect-square">
                <img
                  src="https://readdy.ai/api/search-image?query=Professional%20Korean%20media%20review%20concept%2C%20elegant%20editorial%20photography%20style%2C%20warm%20studio%20lighting%2C%20sophisticated%20creative%20atmosphere%2C%20minimalist%20composition%2C%20soft%20neutral%20tones%2C%20artistic%20magazine%20aesthetic&width=800&height=800&seq=about-testimonial-01&orientation=squarish"
                  alt="媒体评价"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>

            <div className="w-full lg:w-[60%] flex flex-col justify-center">
              <span className="text-xs text-foreground-500 font-medium tracking-wide">
                （媒体与用户评价）
              </span>
              <h2 className="mt-2 font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight">
                行业认可
                <br />
                <span className="text-foreground-400">用户信赖</span>
              </h2>
              <blockquote className="mt-10 md:mt-12 text-foreground-700 text-base md:text-lg leading-relaxed">
                &ldquo;{currentTestimonial.quote}&rdquo;
              </blockquote>
              <p className="mt-6 text-foreground-950 font-semibold text-sm md:text-base">
                &mdash; {currentTestimonial.author}
              </p>
              <p className="text-xs text-foreground-500">{currentTestimonial.role}</p>

              <div className="mt-8 flex items-center gap-4">
                <button
                  onClick={() => setTestimonialIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length)}
                  className="w-10 h-10 flex items-center justify-center rounded-full border border-foreground-300 text-foreground-600 cursor-pointer hover:border-foreground-500 transition-colors"
                  aria-label="上一条评价"
                >
                  <i className="ri-arrow-left-line text-lg"></i>
                </button>
                <button
                  onClick={() => setTestimonialIndex((prev) => (prev + 1) % testimonials.length)}
                  className="w-10 h-10 flex items-center justify-center rounded-full bg-foreground-950 text-background-50 cursor-pointer hover:bg-foreground-800 transition-colors"
                  aria-label="下一条评价"
                >
                  <i className="ri-arrow-right-line text-lg"></i>
                </button>
              </div>
            </div>
          </div>
        </section>

        {/* Contact CTA */}
        <section className="relative w-full h-[420px] md:h-[500px] overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Wide%20panoramic%20Korean%20webtoon%20style%20illustration%2C%20warm%20coral%20and%20cream%20gradient%20background%2C%20abstract%20flowing%20artistic%20shapes%2C%20cinematic%20wide%20composition%2C%20soft%20dreamy%20atmosphere%2C%20elegant%20modern%20design&width=1600&height=900&seq=about-cta-01&orientation=landscape"
            alt="联系我们"
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-transparent to-black/30"></div>

          <div className="relative z-10 w-full h-full max-w-[1440px] mx-auto px-6 md:px-10 flex flex-col items-start justify-center">
            <h2 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-white max-w-2xl leading-tight">
              联系我们
            </h2>
            <p className="mt-4 text-white/70 text-sm md:text-base max-w-md">
              如果您有任何问题、建议或商务合作意向，欢迎通过以下方式联系我们。我们期待与您的交流。
            </p>
            <a
              href="mailto:hello@acwaterpump.com"
              className="mt-10 whitespace-nowrap px-8 py-3.5 rounded-full border border-white/60 text-white font-medium text-sm cursor-pointer hover:bg-white/10 transition-colors inline-flex items-center gap-3"
            >
              <span>发送邮件</span>
              <span className="w-6 h-6 flex items-center justify-center rounded-full bg-white text-foreground-950">
                <i className="ri-mail-line text-xs"></i>
              </span>
            </a>
          </div>
        </section>

        {/* Contact Info */}
        <section className="py-16 md:py-24 max-w-[1440px] mx-auto px-6 md:px-10">
          <div className="max-w-3xl mx-auto">
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 text-center">
              联系方式
            </h2>
            <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="text-center">
                <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-full bg-primary-100 text-primary-500">
                  <i className="ri-mail-line text-2xl"></i>
                </div>
                <h3 className="mt-4 font-heading text-lg font-semibold text-foreground-950">电子邮箱</h3>
                <p className="mt-2 text-sm text-foreground-600">hello@acwaterpump.com</p>
              </div>
              <div className="text-center">
                <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-full bg-accent-100 text-accent-500">
                  <i className="ri-wechat-line text-2xl"></i>
                </div>
                <h3 className="mt-4 font-heading text-lg font-semibold text-foreground-950">微信公众号</h3>
                <p className="mt-2 text-sm text-foreground-600">韩国漫画网</p>
              </div>
              <div className="text-center">
                <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-full bg-secondary-100 text-secondary-500">
                  <i className="ri-global-line text-2xl"></i>
                </div>
                <h3 className="mt-4 font-heading text-lg font-semibold text-foreground-950">官方网站</h3>
                <p className="mt-2 text-sm text-foreground-600">www.koreancomic.cn</p>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}